import createStyles from '@material-ui/core/styles/createStyles'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Theme } from '@material-ui/core/styles'

const styles = ({ palette, spacing, shadows }: Theme) =>
  createStyles({
    root: {
      '&:hover:not($disabled) svg': {
        color: palette.trunkrs.secondary.violet.base,
      },
      '&:focus:not($disabled) svg': {
        color: palette.trunkrs.secondary.violet.base,
      },
      '&$isCard': {
        backgroundColor: palette.common.white,
        borderRadius: spacing(0.5),
        boxShadow: shadows[1],
      },
      '&:not($isCard) span:last-of-type': {
        fontWeight: 'bold',
      },
      '&$disabled span:last-of-type': {
        color: palette.trunkrs.grayscale.darker,
      },
      '&$isCard$checked': {
        borderColor: palette.trunkrs.secondary.violet.base,
        borderWidth: 2,
        borderStyle: 'solid',
      },
      '&$disabled$isCard': {
        backgroundColor: palette.trunkrs.grayscale.purgatory,
        boxShadow: 'none',
        border: 'none',
      },
      '&$disabled$checked svg': {
        color: `${palette.trunkrs.grayscale.darker}!important`,
      },
    },

    disabled: {},

    checked: {},

    isCard: {},
  })
export default makeStyles(styles)
